import { AppBar, Box, Divider, Drawer, List, ListItemButton, Typography } from "@mui/material";
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from '../services/axiosInstance';
import { enqueueSnackbar } from "notistack";
import { ReactComponent as Logo } from '../static/images/Spiritual-Tara-New.svg';

const drawerWidth = 240;

const Wrapper = ({
  children
}) => {

  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/sign-in')
  }

  useEffect(() => {
    const token = localStorage.getItem('token');

    if(!token){
      navigate('/sign-in')
    }

    axiosInstance.interceptors.response.use((response) => {
      
      return response;
    }, (error) => {

      if(error.status === 401){
        enqueueSnackbar('Session expired ! Please login again', {
          variant : 'error',
          preventDuplicate : true
        })

        setTimeout(() => {
          localStorage.removeItem('token')
          navigate('/sign-in')
        }, 5000)
      }

      return Promise.reject(error);
    })

    // eslint-disable-next-line
  },[])


  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          padding: '0 20px',
          flexDirection: 'row',
          zIndex: '1100',
          gap : '20px'
        }}
      >
        <Logo
          height={50}
        />
        <Typography
          variant="h5"
          fontWeight='300'
        >
          Super Admin
        </Typography>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, paddingTop: '60px', zIndex : 1000 }
        }}
      >
        <List>
          <Link
            to='/'
            className="d-block link"
          >
            <ListItemButton
              selected={pathname === '/'}
            >
              Admin Users
            </ListItemButton>
          </Link>


          <Link
            to='/services'
            className="d-block link"
          >
            <ListItemButton
              selected={pathname === '/services'}
            >
              Services
            </ListItemButton>
          </Link>

          <Link
            to='/bookings'
            className="d-block link"
          >
            <ListItemButton
              selected={pathname === '/bookings'}
            >
              Bookings
            </ListItemButton>
          </Link>

          <Link
            to='/blogs'
            className="d-block link"
          >
            <ListItemButton
              selected={pathname === '/blogs'}
            >
              Blogs
            </ListItemButton>
          </Link>

          <Link
            to='/events'
            className="d-block link"
          >
            <ListItemButton
              selected={pathname === '/events'}
            >
              Events
            </ListItemButton>
          </Link>

          <Link
            to='/modalities'
            className="d-block link"
          >
            <ListItemButton
              selected={pathname === '/modalities'}
            >
              Modalities
            </ListItemButton>
          </Link>

          <Link
            to='/main-questionnaire'
            className="d-block link"
          >
            <ListItemButton
              selected={pathname === '/main-questionnaire'}
            >
              Main Questionnaire
            </ListItemButton>
          </Link>

          <Link
            to='/settings'
            className="d-block link"
          >
            <ListItemButton
              selected={pathname === '/settings'}
            >
              Settings
            </ListItemButton>
          </Link>

          <Divider />

          <ListItemButton
            onClick={handleLogout}
          >
            Logout
          </ListItemButton>

        </List>
      </Drawer>

      <Box
        sx={{
          paddingTop : '80px',
          paddingLeft : `${drawerWidth + 20}px`,
          paddingBottom : '20px',
          paddingRight : '20px'
        }}
      >
        {children}
      </Box>
    </>
  )
}

export default Wrapper;